export const VALIDITY_UNIT = {
    DAYS: 'days',
    WEEKS: 'weeks',
    MONTHS: 'months',
    YEARS: 'years',
};

export const VALIDITY_UNITS_ARRAY = Object.values(VALIDITY_UNIT);
